import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ContactChildrenLightModel,
  ContactDetailModel,
  ContactFormModel,
  ContactModel,
  ContactNameModel,
} from './types';
import { ErrorService } from '../../error';
import { MessageService } from '../../service/message/message.service';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CrudType } from '../../service/message/types';

@Injectable({
  providedIn: 'root',
})
export class ContactApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService,
    private readonly messageService: MessageService,
  ) {}

  getById = (id: number): Observable<ContactDetailModel> => {
    let parameters: string[];
    parameters = [id.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<ContactDetailModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  getFormById = (id: number): Observable<ContactFormModel> => {
    let parameters: string[];
    parameters = [id.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<ContactFormModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  postContact = (contactPost: ContactModel): any => {
    let parameters: string[];
    parameters = [];
    let url = this.formatUrl(parameters);

    let formData = new FormData();
    for (const property in contactPost) {
      if (!!contactPost[property])
        formData.append(property, contactPost[property]);
    }

    return this.httpClient
      .post<ContactModel>(url, formData, { observe: 'response' })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.create),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  updateContact = (contactUpdate: ContactModel): any => {
    let parameters: string[];
    parameters = [contactUpdate.id.toString()];
    let url = this.formatUrl(parameters);

    let formData = new FormData();
    for (const property in contactUpdate) {
      if (!!contactUpdate[property])
        formData.append(property, contactUpdate[property]);
    }

    return this.httpClient
      .post<ContactModel>(url, formData, { observe: 'response' })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.update),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  createInstance = (): Observable<ContactModel> => {
    let parameters: string[];
    parameters = ['create'];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<ContactModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  getChildren = (parentId: number): Observable<ContactChildrenLightModel[]> => {
    let parameters: string[];
    parameters = [parentId.toString(), 'children'];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<ContactChildrenLightModel[]>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  getNewestContactNameByEmail = (
    email: string,
  ): Observable<ContactNameModel> => {
    let parameters: string[];
    parameters = ['email', 'newest'];

    let url = this.formatUrl(parameters);
    return this.httpClient
      .get<ContactNameModel>(url, {
        params: { email },
      })
      .pipe(
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  formatUrl = (parameters: string[]): string => {
    let url = environment.comparanooapiurl;
    url += environment.features.contact.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
